
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Zap, TrendingUp, Clock } from 'lucide-react';

const TrendInsights: React.FC = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Trend Insights</CardTitle>
        <CardDescription>What's working in your genre</CardDescription>
      </CardHeader>
      <CardContent>
        <ScrollArea className="h-[220px] pr-4">
          <div className="space-y-4">
            <div>
              <h3 className="text-sm font-medium flex items-center gap-1.5">
                <Zap className="h-4 w-4 text-yellow-400" />
                Video Length Trends
              </h3>
              <p className="text-sm text-muted-foreground mt-1">
                Short-form videos (15-30s) are generating 3.2x more engagement in your genre this week.
              </p>
            </div>
            
            <Separator />
            
            <div>
              <h3 className="text-sm font-medium flex items-center gap-1.5">
                <TrendingUp className="h-4 w-4 text-green-500" />
                Rising Hashtags
              </h3>
              <div className="flex flex-wrap gap-1.5 mt-1.5">
                <Badge variant="outline" className="bg-background/30">#producerchallenge</Badge>
                <Badge variant="outline" className="bg-background/30">#sounddesign</Badge>
                <Badge variant="outline" className="bg-background/30">#indieartist</Badge>
                <Badge variant="outline" className="bg-background/30">#musicdiary</Badge>
              </div>
            </div>
            
            <Separator />
            
            <div>
              <h3 className="text-sm font-medium flex items-center gap-1.5">
                <Clock className="h-4 w-4 text-blue-400" />
                Best Posting Times
              </h3>
              <p className="text-sm text-muted-foreground mt-1">
                Based on your audience: TikTok (7-9pm), Instagram (12-2pm), Twitter (8-10am).
              </p>
            </div>
          </div>
        </ScrollArea>
      </CardContent>
    </Card>
  );
};

export default TrendInsights;
